__turbopack_context__.v({
  "buttonsContainer": "styles-module___sN5sW__buttonsContainer",
  "message": "styles-module___sN5sW__message",
  "modalContent": "styles-module___sN5sW__modalContent",
  "objectName": "styles-module___sN5sW__objectName",
});
